/** Rendering page 1 costs a full parse, so this budget is tighter than images'. */
export const PDF_THUMBNAIL_MAX_BYTES = 10 * 1024 * 1024;

/** Above this a PDF downloads instead of opening in the viewer. */
export const PDF_PREVIEW_MAX_BYTES = 50 * 1024 * 1024;

export const PDF_PREVIEW_INSET_PX = 8;

/** Rendered width of a PDF page at 100% zoom. */
export const PDF_PAGE_WIDTH_PX = 800;

export const PDF_ZOOM_MIN = 0.5;
export const PDF_ZOOM_MAX = 3;
export const PDF_ZOOM_STEP = 0.25;
